export function PageHeader({ title, children, actions, className, sticky = true, customLayout = false }) {
    return (
        <div
            className={`w-full bg-background border-b border-border ${sticky ? 'sticky top-0 z-40' : ''} ${className}`}
        >
            <div className="px-4 sm:px-[20px] py-3 sm:py-[18px] flex items-center gap-2 sm:gap-[12px]">
                {/* Left content (e.g., Breadcrumb) */}
                {children && <div className={customLayout ? 'min-w-0 flex-1' : 'shrink-0'}>{children}</div>}

                {/* Title */}
                {title && (
                    <h1
                        className={
                            'text-[20px] font-semibold text-foreground ' + (customLayout ? 'flex-1' : 'shrink-0')
                        }
                    >
                        {title}
                    </h1>
                )}

                {/* Spacer - pousse les actions à droite */}
                {!customLayout && <div className="flex-1" />}

                {/* Right actions */}
                {actions && <div className="flex items-center gap-2 sm:gap-[8px] shrink-0">{actions}</div>}
            </div>
        </div>
    );
}
